export var BadgeTestIds = {
    /** Test ID to grab the container */
    CONTAINER: 'hawkins-badge-container',
    /** Test ID to grab the circle */
    CIRCLE: 'hawkins-badge-circle',
    /** Test ID to grab the label */
    LABEL: 'hawkins-badge-label',
    /** Test ID to grab the end adornment */
    END_ADORNMENT: 'hawkins-badge-end-adornment',
};
